import { useMutation, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { getPointCentralClientMappingQueryKey } from './get-point-central-client-mapping'

type UnauthorizePointCentralRequest = {
  buildingId: number
  clientId: string
}

const unauthorizePointCentral = async (data: UnauthorizePointCentralRequest) => {
  const response = await authAPI.post(`/building/${data.buildingId}/point-central/un-authorize`, {
    clientId: data.clientId,
  })
  return response.data
}

export const useUnauthorizePointCentral = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: unauthorizePointCentral,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: getPointCentralClientMappingQueryKey({
          buildingId: variables.buildingId,
          clientId: variables.clientId,
        }),
      })
    },
  })
}
